import { FC } from 'react';
import { CheckCircleIcon, CloseIcon } from '../../../../icons';

interface ResendCodeSentMessageProps {
  onDismiss: () => void;
}

const ResendCodeSentMessage: FC<ResendCodeSentMessageProps> = ({ onDismiss }) => (
  <div className="flex w-full items-center justify-between gap-3 rounded-xl border border-green-2 bg-green-1 px-4 py-3">
    <div className="flex items-center gap-2">
      <CheckCircleIcon width={20} height={20} className="shrink-0 text-green-4" />
      <span className="font-bold text-green-6">Verification code sent</span>
    </div>
    <button type="button" onClick={onDismiss} aria-label="Dismiss">
      <CloseIcon width={16} height={16} className="text-green-4" />
    </button>
  </div>
);

export default ResendCodeSentMessage;
